import React, { ReactNode } from "react";

import { useLocation } from "react-router-dom";

import useIdleEffect from "../../bit/board/hooks/useIdleEffect";
import { useCallActive } from "../CallActive";

interface IdleProviderProps {
  children: ReactNode;
  onIdle: () => void;
}

const routeTimeouts: { pattern: RegExp; timeout: number }[] = [
  { pattern: /^\/video-call/, timeout: 300000 },
  { pattern: /teams-(video|audio)-(group-)?call/, timeout: 300000 },
  { pattern: /\/call$/, timeout: 120000 },
  { pattern: /^\/door/, timeout: 7000 },
  { pattern: /^\/access-control/, timeout: 10000 },
  { pattern: /.*/, timeout: 60000 }, // This pattern must be at the end
];

const IdleWatcher = ({
  onIdle,
  timeout,
  active,
}: {
  onIdle: () => void;
  timeout: number;
  active: boolean;
}) => {
  useIdleEffect(onIdle, timeout, active);

  return null;
};

export const IdleProvider: React.FC<IdleProviderProps> = ({
  children,
  onIdle,
}) => {
  const location = useLocation();

  const { callActive } = useCallActive();

  const timeout =
    routeTimeouts.find((route) => route.pattern.test(location.pathname))
      ?.timeout || 60000;

  return (
    <>
      <IdleWatcher
        key={callActive ? "call" : "idle"}
        onIdle={onIdle}
        timeout={timeout}
        active={!callActive}
      />
      {children}
    </>
  );
};
